import { memo as Memo, useState, useMemo } from 'react';

//* Components
import AwardsArrow from '@components/global/Awards/AwardsArrow';
import CustomLink from '../../CustomLink';
import Text from '../../Text';

const AwardsWhite = Memo(({ ...item }) => {
	//! States
	const [act, setAct] = useState(false);

	const elementInner = useMemo(
		() => (
			<>
				<div className={'awardsItemCont'}>
					<div className={'awardsItemInfo1'}>
						<Text
							tag={'h4'}
							className={'h6 awardName font-poppins font-regular'}>
							{item.title}
						</Text>

						<Text className={`p-m font-poppins font-light awardsItemDescription`}>{item.description}</Text>
					</div>

					<div className={'awardsItemInfo2'}>
						<Text className={`p-m font-poppins font-light awardsYear`}>{item.year}</Text>

						<div className={`crCircle awardsLink`}>
							<Text className={'p-m font-poppins font-light'}>{item.project_url.replace(/(^\w+:|^)\/\//, '')}</Text>
						</div>
					</div>
				</div>

				<div className={'awardsItemWrapIcon'}>
					<AwardsArrow active={act} />
				</div>
			</>
		),
		[act]
	);

	return item.award_url ? (
		<CustomLink
			external
			url={item.award_url}
			onMouseEnter={() => setAct(true)}
			onMouseLeave={() => setAct(false)}
			className={'awardsItemColumn-white'}>
			{elementInner}
		</CustomLink>
	) : (
		<div
			onMouseEnter={() => setAct(true)}
			onMouseLeave={() => setAct(false)}
			className={'awardsItemColumn-white'}>
			{elementInner}
		</div>
	);
});

export default AwardsWhite;
